import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {SignupForm} from '../../../models/';
import {AuthService, ScrollService, UserService, MessagesServices} from '../../api/';
import {Observable} from 'rxjs/Observable';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {MdDialog, MdDialogRef} from '@angular/material';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css']
})
export class SignupComponent implements AfterViewInit, OnDestroy, OnInit {
    private model: SignupForm;
    private errorArray: Array<any> = [];
    private registrationSuccessfull: boolean = false;
    private direct: boolean = false;
    private request: boolean = false;
    private signup: boolean = false;
    private inputSubscriber: any = null;
    private checkAvailibilitySubscriber = null;
    private checkReferralCode: boolean = false;
    dialogRef: MdDialogRef<LogoutsDialog>;
    private token: string = '';
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline: boolean = navigator.onLine;

    constructor(private authService: AuthService, private sm: MessagesServices, private route: ActivatedRoute, private router: Router,
    private scrollService: ScrollService, public dialog: MdDialog, private userService: UserService, private toastyService: ToastyService,) {
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false;});

        this.blockUI.start('Loading...');
        this.model = new SignupForm();
        if (this.authService.isUserLoggedIn() && !this.route.snapshot.data['done']) {
            this.router.navigate(['']);
        }
        if (this.route.snapshot.data['done'] === true) {
            this.registrationSuccessfull = true;
        }
        if (this.route.snapshot.data['direct'] === true) {
            this.direct = true;
        }
        if (this.route.snapshot.data['request'] === true) {
            this.request = true;
        }
        this.route.params.subscribe((params) => {
            if (params['referral_code']) {
                this.model.referral_code = params['referral_code'];
            }

            if (this.authService.isUserLoggedIn() && params['referral_code']) {


                this.token = params['referral_code'];
                if (this.token.length > 0) {

                    this.dialogRef = this.dialog.open(LogoutsDialog, {
                        disableClose: false,
                        width: '400px',
                        height: '200px',
                    });

                    this.dialogRef.componentInstance.token = this.token;
                }

            }

        });
        if(this.onlineOffline){
        this.userService.checkValidReferral(this.model.referral_code).subscribe((res) => {
            this.checkReferralCode = res;
            this.signup = !res;
        });
        }
        //getting messages from db
        this.messages = this.sm.messags;
        this.setMessages();

        this.blockUI.stop(); // Stop blocking
    }

    ngOnInit(){
        this.scrollService.enableScrollIfDisabled();
    }

    /**
     * setting system messages
     **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_VERIFICATION_EMAIL_SENT_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_EMAIL_NOT_FOUND') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
            }
        }
    }

    ngAfterViewInit() {
        this.scrollService.toggleProgressBar(false);
        this.inputSubscriber = this.inputChanges(300).subscribe(
            input => this.trimSpaces()
        );
        this.scrollService.toggleProgressBar(false);
        this.route.queryParams.subscribe((queryParams: any) => {
            if (queryParams.referral_code) {
                this.model.referral_code = queryParams.referral_code;
            }
        });
    }

    submitSignupForm() {
        this.blockUI.start();
        this.scrollService.toggleProgressBar(true);
        if(this.onlineOffline) {
            this.userService.checkScreenNameAvailibility(this.model.screenname).subscribe((res) => {
                if (res === true) {
                    this.authService.signup(this.model).subscribe((res) => {
                        this.scrollService.toggleProgressBar(false);
                        this.blockUI.stop();
                        localStorage.setItem('resendemail', this.model.email);
                        this.router.navigate(['signup/done']);
                    }, (err) => {
                        this.scrollService.toggleProgressBar(false);
                        this.blockUI.stop();
                        this.handleErrors(err);
                    });
                } else {
                    this.scrollService.toggleProgressBar(false);
                    this.blockUI.stop();
                    this.errorArray['screenname'] = 'This screen name is not available.';
                }
            });
        }
    }

    submitReferralForm() {
        this.scrollService.toggleProgressBar(true);
        if(this.onlineOffline){
        this.authService.failedReferral(this.model).subscribe((res) => {
            this.scrollService.toggleProgressBar(false);
            this.router.navigate(['signup/request']);
        }, (err) => {
            this.scrollService.toggleProgressBar(false);
            this.handleErrors(err);
        });
        }
    }

    resendConfirmEmail() {
        if(this.onlineOffline) {
            this.authService.resendComfirmEmail(btoa(localStorage.getItem('resendemail'))).subscribe((res) => {
                let response = res.json();
                if (response.code == 'ok') {
                    let toastOptions: ToastOptions = {
                        title: this.title1,
                        msg: this.msg1,
                        showClose: true,
                        timeout: 2000,
                        theme: 'default'
                    };
                    this.toastyService.success(toastOptions);
                } else {
                    let toastOptions: ToastOptions = {
                        title: this.title2,
                        msg: this.msg2,//Email Not Found
                        showClose: true,
                        timeout: 2000,
                        theme: 'default'
                    };
                    this.toastyService.error(toastOptions);
                }
                this.router.navigate(['signup/done']);
            });
        }
    }

    handleErrors(err: any) {
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }

    trimSpaces() {
        this.model.screenname = this.model.screenname.replace(/\s+/g, '_');
        this.model.screenname = this.model.screenname.replace(/_{2,}/g, '_');
        this.model.screenname = this.model.screenname.replace(/-{2,}/g, '-');
        if (this.checkAvailibilitySubscriber != null) {
            this.checkAvailibilitySubscriber.unsubscribe();
        }
        this.checkAvailibilitySubscriber = this.userService.checkScreenNameAvailibility(this.model.screenname).subscribe((res) => {
            if (res === false) {
                this.errorArray['screenname'] = 'This screen name is not available.';
            } else {
                this.errorArray['screenname'] = '';
            }
        }, (err) => {
        });
    }

    checkReferral() {
        if(this.onlineOffline){
        this.userService.checkValidReferral(this.model.referral_code).subscribe((res) => {
            if (res === false) {
                this.errorArray['referral_code'] = 'This referral code is not valid or expire.';
            } else {
                this.errorArray['referral_code'] = '';
            }
        }, (err) => {
        });
        }
    }

    getScreenNameError() {
        let err = {
            length: true,
            initial: true,
            end: true,
            full: true
        };
        let INITAL_REGEXP = /^[a-zA-Z0-9]{1}/;
        let END_REGEXP = /[a-zA-Z0-9]$/;
        let REGEXP = /^[a-zA-Z0-9]+([a-zA-Z0-9_\-.])+[a-zA-Z0-9]$/;
        if (this.model.screenname.length < 4) {
            err.length = false;
        } else if (!INITAL_REGEXP.test(this.model.screenname)) {
            err.initial = false;
        } else if (!END_REGEXP.test(this.model.screenname)) {
            err.end = false;
        } else if (!REGEXP.test(this.model.screenname)) {
            err.full = false;
        }
        this.errorArray['screennameValidation'] = err;
    }

    emitInput: (event: KeyboardEvent) => void;

    //sets up emitInput to start sending values
    inputChanges(debounce: number): Observable<string> {
        return Observable.create(observer => {
            this.emitInput = (event: KeyboardEvent) => {
                observer.next((<HTMLInputElement>event.target).value);
            };
        }).distinctUntilChanged().debounceTime(debounce);
    }

    ngOnDestroy() {
        this.inputSubscriber.unsubscribe();
    }
}


@Component({
    selector: 'dialog-logout',
    templateUrl: 'logout.component.html',
})
export class LogoutsDialog implements OnInit {
    public token: string = '';

    constructor(public dialogRef: MdDialogRef<LogoutsDialog>, private sm: MessagesServices, private userService: UserService, private authService: AuthService, private router: Router) {
    }

    ngOnInit() {
    }

    confirmSelection() {
        this.signOut();
        this.router.navigate(["signup", "referral_code", this.token]);
        this.dialogRef.close();
    }

    signOut() {
        this.authService.logOut();
        this.userService.getUserEventEmitter().emit({'name': 'user:logout'});
    }

}


// WEBPACK FOOTER //
// ./src/app/user/signup/signup.component.ts